<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { AloDbMission } from '@/models/alodb/AloDbMission'
import AdminMissionUserRights from '@/components/admin/adminMission/AdminMissionUserRights.vue'
import AdminForm from '@/components/admin/AdminForm.vue'


@Component({
  name: 'AdminMissionUserRightsTab', 
  components:{AdminMissionUserRights}
})
export default class AdminUser extends AdminForm<AloDbMission> {    
  get itemTypeName(){
    return "AdminMission"
  }

  get componentName(){
    return "AdminMissionUserRights"
  }

  get showActionArea() {
    return false
  }

  get showTitle(){
    return false
  }
  
}
</script>